import React from 'react';
import App from './App';
import './index.css';
import { Amplify } from 'aws-amplify';
import awsconfig from './aws-exports';
import { createRoot } from 'react-dom/client';

// Configure Amplify with the settings from the aws-exports file
// console.log('AWS Configuration:', awsconfig);
Amplify.configure(awsconfig);

createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
